/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_ReadyInputs */

const cs_property_ai_catalog_ready = /** @type {(inputs: Property_Ai_Catalog_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální PDF`)
};

const en_property_ai_catalog_ready = /** @type {(inputs: Property_Ai_Catalog_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest PDF`)
};

/**
* | output |
* | --- |
* | "Latest PDF" |
*
* @param {Property_Ai_Catalog_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_ready = /** @type {((inputs?: Property_Ai_Catalog_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_ready(inputs)
	return cs_property_ai_catalog_ready(inputs)
});